import {
    IRequestResponse,
    IBrand,
    ICountry,
    IAffiliate,
    ITypeOfCampaign,
    ITypeOfAssets,
    IMedia,
    IRequestStatus,
    IRequest,
    IMessage,
    IRequestFile,
    IStatisticsResponse,
    IGlobalSettings,
    IDecisionMessage,
    ITheme,
} from "@/models";

interface IRequestState {
    affiliates: IAffiliate[];
    brands: IBrand[];
    countries: ICountry[];
    isReferenceDataLoaded: boolean;
    typesOfCampaign: ITypeOfCampaign[];
    typesOfAssets: ITypeOfAssets[];
    media: IMedia[];
    messages: IMessage[];
    requestStatus: IRequestStatus[];
    userRequests: IRequestResponse;
    singleRequest: IRequest;
    uploadFiles: IRequestFile[];
    statisticsRequest: IStatisticsResponse;
    globalSettings: IGlobalSettings;
    decisionMessages: IDecisionMessage[];
    themes: ITheme[];
}

const initialState: IRequestState = {
    affiliates: null,
    brands: null,
    countries: null,
    isReferenceDataLoaded: false,
    typesOfCampaign: null,
    typesOfAssets: null,
    media: null,
    messages: null,
    requestStatus: null,
    userRequests: null,
    singleRequest: null,
    uploadFiles: null,
    statisticsRequest: null,
    globalSettings: null,
    decisionMessages: null,
    themes: null
};

export { IRequestState, initialState };
